/* eslint-disable react-hooks/exhaustive-deps */
//default
// import React, { useState, useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { DropDown, Input } from "../../../components";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { getLastDate, validatePositiveValue } from "../../../utilities/utils";
import { differenceInCalendarDays, format } from "date-fns";
import Select from "react-select";
import { WeekOptions } from "../../Coaching/CreateSession";
import { useEffect, useState } from "react";
import { WEEK_DAYS } from "../../../utilities/utils";

const CoachBooking = ({
  allSportsData = [],
  allSessionsData = [],
  data = {},
  updateData = () => {

  },
  sessionData = {},
  sportData = {},
}: any) => {
  const [calendarDay, setCalendarDay] = useState<any>([]);

  const handleSelectedSlot = (value: any) => {
    let temp = [] as any;

    if (value?.length <= data?.noOfDays) {
      updateData("selectedSlots", value);
      value?.map?.((elem: any) =>
        sessionData?.sessionSlots.forEach((_slot: any) => {
          if (elem.value === _slot?.id) {
            temp.push(WEEK_DAYS.indexOf(_slot?.sessionDay));

            setCalendarDay(temp);
          }
        })
      );
    } else {
      updateData("selectedSlots", data?.selectedSlots);
      setCalendarDay(calendarDay);
    }
  };

  useEffect(() => {
    if (data?.selectedSlots.length > 0) {
      let temp = [] as any;
      data?.selectedSlots?.map?.((elem: any) =>
        sessionData?.sessionSlots.forEach((_slot: any) => {
          if (elem.value === _slot?.id) {
            temp.push(WEEK_DAYS.indexOf(_slot?.sessionDay));

            setCalendarDay(temp);
          }
        })
      );
    }
  }, []);
  const setPositiveValue = (key = "", value = "") => {
    if (validatePositiveValue(value)) {
      updateData(key, value);
    }
  };

  const getFormatedDate = (_date: string) => {
    if (!_date) {
      return new Date();
    }
    if (_date?.includes?.("GMT")) {
      return new Date(_date);
    }
    const [_dd, _mm, _yy] = _date?.split?.("/") || [];
    return new Date(`${_mm}/${_dd}/${_yy}`);
  };

  const isDayDisabled = () => {
    const currentDate = new Date();
    const day = currentDate.getDay();
    const date = currentDate.getDate();
    let AddDays = 0;
    if (day !== 0) {
      AddDays = 7 - day;
    }

    return currentDate.setDate(date + AddDays);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <Card.Title className="text-start">Coaching Booking</Card.Title>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="selectsport" className="form-label">
                    Select Sport
                  </label>
                  <DropDown
                    onChange={(e: any) => {
                      updateData("sportId", Number(e?.target?.value));
                      updateData("selectedSlots", []);
                    }}
                    value={data?.sportId}
                    className="form-control"
                    id="selectsport"
                    name="selectsport"
                  >
                    <option value="">Select Sport</option>
                    {allSportsData?.map?.((_sport: any) => (
                      <option key={_sport.id} value={_sport?.id}>
                        {_sport?.name}
                      </option>
                    ))}
                  </DropDown>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label
                    htmlFor="selectno-of-session-per-week"
                    className="form-label"
                  >
                    Select No. of session per week
                  </label>
                  <DropDown
                    className="form-control"
                    id="addcharges"
                    value={data?.noOfDays}
                    onChange={(e: any) =>
                      updateData("noOfDays", Number(e?.target?.value))
                    }
                  >
                    <option value="">Select session per week</option>
                    {WeekOptions?.map?.((_opt: any) => (
                      <option key={_opt?.label} value={_opt?.value}>
                        {_opt?.label}
                      </option>
                    ))}
                  </DropDown>
                </div>
              </Col>
              <Col lg={12}>
                <div className="mb-3 text-start">
                  <label htmlFor="selectsport" className="form-label">
                    Available Sessions
                  </label>
                  <DropDown
                    onChange={(e: any) => {
                      updateData("sessionId", Number(e?.target?.value));
                      updateData("selectedSlots", []);
                    }}
                    value={data?.sessionId}
                    className="form-control"
                    id="availablesession"
                    name="availablesession"
                  >
                    <option>Select Session</option>
                    {allSessionsData?.map?.((_session: any) => {
                      const rate = _session?.sessionRates?.find?.(
                        (_rate: any) => _rate?.noOfDays === data?.noOfDays
                      );
                      return (
                        <option key={_session.id} value={_session?.id}>
                          {`${_session?.name}'s: Starting Date: ${_session?.startDate}; Charges per Session: ${rate?.ratePerSession}`}
                        </option>
                      );
                    })}
                  </DropDown>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label
                    htmlFor="selected-daysto-attend"
                    className="form-label"
                  >
                    Select days to attend
                  </label>
                  <Select
                    className="select-dropdown"

                    options={
                      sessionData?.sessionSlots?.map?.((_slot: any) => ({
                        label: `${_slot?.sessionDay} ${_slot?.startTime} to ${_slot?.endTime}`,
                        value: _slot?.id,
                      })) || []
                    }
                    isMulti={true}

                    closeMenuOnSelect={false}
                    placeholder="Select Days"
                    defaultValue={data?.selectedSlots || []}
                    value={data?.selectedSlots || []}
                    onChange={handleSelectedSlot}
                    isDisabled={!data?.sessionId}

                  />
                </div>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="addweeks" className="form-label">
                        Add weeks for booking
                      </label>
                      <Input
                        onChange={(e: any) => {
                          e?.target?.value.length <= 2 &&
                            setPositiveValue("noOfWeeks", e?.target?.value);
                        }}
                        value={data?.noOfWeeks}
                        type="number"
                        name="noOfWeeks"
                        id="noOfWeeks"
                        className="form-control"
                        onKeyDown={(e: any) =>
                          ["e", ".", "-", "+"].includes(e.key) &&
                          e.preventDefault()
                        }
                        onWheel={(e: any) => e.target.blur()}
                      />
                      {data?.noOfWeeks &&
                        data?.noOfWeeks < sessionData?.minWeeksToBook && (
                          <div className="error-msg">
                            Number of week can not be less than{" "}
                            {sessionData?.minWeeksToBook}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label className="form-label me-1">Start Date</label>
                      <DatePicker
                        mapDays={({ date }) => {
                          let isDisable = !calendarDay.includes(
                            date.weekDay.index
                          );
                          if (isDisable)
                            return {
                              disabled: true,
                              style: { color: "#ccc" },
                            };
                        }}
                        id="startdate"
                        inputClass="form-control"
                        format="DD/MM/YYYY"
                        containerClassName="custom-container"
                        onChange={(date: any) => {
                          updateData("startDate", date?.toDate().toUTCString());
                        }}
                        value={new Date(data?.startDate)}
                        render={<InputIcon className="form-control" />}
                        minDate={
                          isDayDisabled()
                            ? isDayDisabled()
                            : differenceInCalendarDays(
                              getFormatedDate(sessionData?.startDate),
                              new Date()
                            ) > 0
                              ? getFormatedDate(sessionData?.startDate)
                              : new Date()
                        }
                        maxDate={
                          sessionData?.endDate
                            ? getFormatedDate(sessionData?.endDate)
                            : new Date(
                              new Date().setFullYear(
                                new Date().getFullYear() + 1
                              )
                            )
                        }
                        editable={false}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={6}>
                <ul className="list-group text-start mb-3">
                  <li className="list-group-item">
                    Weekly Charges:{" "}
                    {sessionData?.sessionRates?.find?.(
                      (_rate: any) => _rate?.noOfDays === data?.noOfDays
                    )?.ratePerSession * data?.noOfDays || ""}
                  </li>

                  {sessionData?.sessionOffers?.map?.((_offer: any) => (
                    <li key={_offer?.id} className="list-group-item">
                      {_offer?.noOfWeeks} Weeks Charges (
                      {_offer?.discountPercent}% off)
                    </li>
                  ))}
                  <li className="list-group-item">
                    Minimum no.of weeks enroll: {sessionData?.minWeeksToBook}
                  </li>
                </ul>
              </Col>
              <Col lg={6}>
                <Card className="mb-3">
                  <Card.Body className="p-3">
                    <Card.Title className="fs-6 fw-semibold h5 mb-2 text-start"></Card.Title>
                    <ul className="list-group list-group-flush text-start fw-semibold">
                      <li className="list-group-item">
                        <span className="text-info">Selected Session: </span>{" "}
                        {sessionData?.name}
                      </li>
                      <li className="list-group-item">
                        <span className="text-info">
                          Selected Sessions per Week :{" "}
                        </span>{" "}
                        {data?.noOfDays}
                      </li>

                    </ul>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card className="mb-3">
                  <Card.Body className="p-3">
                    <Card.Title className="fs-6 fw-semibold h5 mb-2 text-start">
                      Assigned schedule for Sessions:
                    </Card.Title>
                    {data?.startDate && data?.noOfWeeks && (
                      <p className="fs-7 fst-italic fw-semibold ms-2 text-start mb-0">
                        {format(new Date(data?.startDate), "do MMM yyyy")} to{" "}
                        {format(
                          getLastDate(
                            new Date(data?.startDate),
                            Number(data?.noOfWeeks)
                          ),
                          "do MMM yyyy"
                        )}
                      </p>
                    )}
                    <ul className="list-group list-group-flush text-start">

                      {sessionData?.sessionSlots?.map?.((_slot: any) => {
                        if (
                          !data?.selectedSlots?.find?.(
                            (_id: any) => _id === _slot?.id
                          )
                        ) {
                          return null;
                        }
                        return (
                          <li key={_slot?.id} className="list-group-item">
                            {`${_slot?.sessionDay} - ${_slot?.startTime} to ${_slot?.endTime}`}
                          </li>
                        );
                      })}
                      <li className="list-group-item">
                        Minimum no.of weeks enroll:{" "}
                        {sessionData?.minWeeksToBook}
                      </li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>


              <Col lg={12}>
                <Card>
                  <Card.Body className="p-3">
                    <Card.Title className="card-title h5 text-start mb-2">
                      Rules of Session
                    </Card.Title>
                    <ol className="list-group list-group-flush list-group-numbered text-start">
                      {sessionData?.sessionRules?.map?.(({ rule }: any) => (
                        <li key={rule?.id} className="list-group-item">
                          {rule?.subject}
                        </li>
                      ))}
                    </ol>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { CoachBooking };
